import { gql } from '@apollo/client';

export const GET_INVENTORY = gql`
  query getInventories($productId: ID!) {
    getInventory(input: { productId: $productId }) {
      id
      product {
        id
        name
        type
        sku
        uom
        description
        active
        supplier {
          id
          name
          description
          location {
            location
            lat
            lng
          }
          phone
        }
      }
      date
      quantity
      details
      createdBy {
        id
        firstName
        lastName
        email
        type
      }
      createdAt
      updatedBy {
        id
        firstName
        lastName
        email
        type
      }
      lastUpdate
    }
  }
`;
